exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header__logo[_v-612bb15e]{background-color:#1e2d7d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-612bb15e&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/layout/elements/header-dashboard.vue
// module id = 361
// module chunks = 0